import React, { useState, useEffect, useRef, useCallback } from "react";
import Sidebar from "../../../components/sidebar";
import { useOutletContext } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "react-bootstrap";
import "./style.scss";
import SearchIcon from "../../../icons/SearchIcon";
import { useDispatch, useSelector } from "react-redux";
import { CommonPagination } from "../../../core/components/common/CommnPagination";
import ThreeDotsIcon from "../../../icons/ThreeDotsIcon";
import EditGreyIcon from "../../../icons/EditGreyIcon";
import ArchiveGreyIcon from "../../../icons/ArchiveGreyIcon";
import { getNonRealLogHourList } from "../../../core/data/redux/nonRealLogHour/_nonRealLogHourAction";
import {
  formatDateStringType,
  logHourFormatTime,
} from "../../../constants/date";
import NonRealLogHourModal from "../../../core/components/modals/nonRealLogHourModal";
import DeleteModal from "../../../components/deleteModal";
import { DeleteModalType } from "../../../constants/utlis";
import { apiPageLimit } from "../../../constants/common";
import PlusIcon from "../../../icons/PlusIcon";

const LogEntry: React.FC = () => {
  const { isSidebarOpen } = useOutletContext<{
    isSidebarOpen: boolean;
    onToggleSidebar: () => void;
  }>();
  const dispatch: any = useDispatch();

  const logHourDetails = useSelector((state: any) => state?.nonRealLogHour);
  const logHourData = logHourDetails?.nonRealLogHourList;
  const totalCount = logHourDetails?.totalCount;

  const [page, setPage] = useState<number>(1);
  const pageSize = apiPageLimit;

  const [searchQuery, setSearchQuery] = useState<string>("");
  const [participationLevel, setParticipationLevel] = useState<string>("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [modalType, setModalType] = useState<DeleteModalType>("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDataUuid, setSelectedDataUuid] = useState<string | null>(null);
  const [showNonRealLogHourModal, setShowNonRealLogHourModal] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);

  // Fetch log-hour list on component mount
  useEffect(() => {
    dispatch(getNonRealLogHourList({}));
  }, [dispatch]);

  // Debounce search
  const debounce = (func: (...args: any[]) => void, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  // Fetch log-hour list with debounce
  const fetchNonRealLogHour = useCallback(
    debounce((search: string, page: number, participationLevel: string) => {
      const params: any = { page, limit: pageSize };
      if (search) params.search = search;
      if (participationLevel) params.participation_level = participationLevel;
      dispatch(getNonRealLogHourList(params));
    }, 500),
    [dispatch]
  );

  // Run when searchQuery or selected changes
  useEffect(() => {
    fetchNonRealLogHour(searchQuery, page, participationLevel);
  }, [searchQuery, page, participationLevel, fetchNonRealLogHour]);

  const totalPages = Math.ceil(totalCount / pageSize);

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleOpenDeleteModal = (type: DeleteModalType, uuid: string) => {
    setModalType(type);
    setSelectedDataUuid(uuid);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedDataUuid(null);
  };

  const handleOpenLogHourModal = (uuid: string) => {
    setSelectedDataUuid(uuid);
    setShowNonRealLogHourModal(true);
  };

  const handleCloseLogHourModal = () => {
    setShowNonRealLogHourModal(false);
    setSelectedDataUuid(null);
  };

  const handleClearAllFilters = () => {
    setSearchQuery("");
    setParticipationLevel("");
  };

  return (
    <div className="layout">
      <Sidebar isOpen={isSidebarOpen} />

      <main className="content">
        <div className="profileSettings log-entry-page-section">
          <div className="rounded log-entry-page">
            <div className="add-properties-heading d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
              <h2 className="mb-0">Log Hours</h2>
              <Button
                className="log-time-button btn primaryButton  btn-primary d-inline-flex justify-content-center align-items-center  btn-block"
                variant="primary"
                onClick={(event) => {
                  handleOpenLogHourModal("");
                }}
              >
                <PlusIcon /> Log Hours
              </Button>
            </div>

            <div className="g-3 mb-3 row-boder-line p-3">
              <div className="row">
                {/* Search log hours */}
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-9 mt-1 mb-1 ">
                  <div className="input-group commonInput bg-light bg-white">
                    <span className="input-group-text bg-white border-end-0 ">
                      <SearchIcon />
                    </span>
                    <input
                      type="text"
                      placeholder="Search log hours "
                      className="name form-control border-start-0"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>

                {/* Participation Level */}
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-2 mt-1 mb-1">
                  <select
                    className="form-select form-control commonInput"
                    value={participationLevel}
                    onChange={(e) => setParticipationLevel(e.target.value)}
                  >
                    <option value="" disabled selected hidden>
                      Participation Level
                    </option>
                    <option value="">Both</option>
                    <option value="active">Active</option>
                    <option value="passive">Passive</option>
                  </select>
                </div>

                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-1 mt-1 mb-1">
                  <div className="clear-all-button">
                    <button onClick={() => handleClearAllFilters()}>
                      Clear All
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className=" g-3 mt-3 mb-3 pb-3 pt-3 row-boder-line">
              <div className="row g-3 ">
                <div className="col-sm-12">
                  <div
                    className={`grid-container mt-0 ${
                      logHourData?.length > 0 ? "" : "noData"
                    }`}
                  >
                    {logHourData?.length > 0 ? (
                      logHourData?.map((logHour: any) => {
                        return (
                          <div className="box ">
                            <div className="custom-card mx-auto">
                              <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center flex-wrap">
                                  <span
                                    // className="category-badge"
                                    className={
                                      logHour?.participation_level.toLowerCase() ==
                                      "active"
                                        ? "category-badge"
                                        : "category-badge tag-sky-blue"
                                    }
                                  >
                                    {logHour?.participation_level}
                                  </span>

                                  <div className="dropdown">
                                    <button
                                      className="three-dot-btn rotate90"
                                      type="button"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <ThreeDotsIcon />
                                    </button>

                                    <ul className="dropdown-menu dropdown-menu-end">
                                      <li
                                        onClick={(event) => {
                                          event.stopPropagation(); // Prevent click from bubbling to parent
                                          handleOpenLogHourModal(logHour?.uuid);
                                        }}
                                      >
                                        <a className="dropdown-item" href="#">
                                          <EditGreyIcon />
                                          Edit
                                        </a>
                                      </li>
                                      <li
                                        onClick={(event) => {
                                          event.stopPropagation(); // Prevent click from bubbling to parent
                                          handleOpenDeleteModal(
                                            "archiveNonRealLogHour",
                                            logHour?.uuid
                                          );
                                        }}
                                      >
                                        <a className="dropdown-item " href="#">
                                          <ArchiveGreyIcon />
                                          Archive
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                <div className="visit-text mt-3 mb-3 text-left">
                                  <h5 className="mb-0 fw-bold">
                                    {logHour?.type?.name}
                                  </h5>
                                  <p className="text-black text-left">
                                    {logHour?.task_description}
                                  </p>
                                </div>
                              </div>

                              <div className="status-row d-flex justify-content-between align-items-center flex-wrap">
                                <div className="sun">
                                  <span className="tag text-black text-left">
                                    {" "}
                                    Date:{" "}
                                  </span>
                                  <span className="tag tag-grey">
                                    {formatDateStringType(logHour?.date)}{" "}
                                  </span>
                                </div>
                                <span className="time-badge">
                                  {logHourFormatTime({
                                    hours: logHour?.hours,
                                    minutes: logHour?.minutes,
                                  })}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <p className="text-center w-100 py-4">
                        No log hours found.
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Pagination */}
            <CommonPagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={setPage}
            />
          </div>
        </div>
      </main>

      {/* non real log-hour Modal */}
      <NonRealLogHourModal
        show={showNonRealLogHourModal}
        onHide={handleCloseLogHourModal}
        uuid={selectedDataUuid}
        // onSuccess={}
      />

      {/* Delete Modal */}
      <DeleteModal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        type={modalType}
        uuid={selectedDataUuid}
      />
    </div>
  );
};

export default LogEntry;
